import React from 'react';
import { Select } from '@hub/select';
import { jsx as _jsx } from "react/jsx-runtime";
export const CategoryList = _ref => {
  let {
    categories,
    value,
    placeholder,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsx(Select, {
    value: value,
    placeholder: placeholder || 'Select an item',
    sx: {
      paddingRight: 'spacing-xl',
      textAlign: 'left',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    onChange: e => onChange(e.target.value),
    "data-id": "store-list_category-list_CategoryList_Select",
    children: categories.map(category => /*#__PURE__*/_jsx("option", {
      value: category.title,
      "data-id": "store-list_category-list_CategoryList_option",
      children: category.title
    }, category.id))
  });
};